import { Badge } from '@/components/ui/badge'
import type {
  CustomerApplicationFieldSourceState,
  CustomerApplicationFieldValueContract,
} from '@/contracts/customer-application-binding'
import { cn } from '@/lib/utils'

const sourceStateMeta: Record<
  CustomerApplicationFieldSourceState,
  {
    label: string
    description: string
    variant: 'default' | 'secondary' | 'success' | 'warning' | 'outline'
  }
> = {
  prefilled_from_question: {
    label: '問卷帶入',
    description: '此欄位由問卷問題自動帶入。',
    variant: 'success',
  },
  overridden: {
    label: '已覆寫',
    description: '此欄位原本由問卷帶入，已被手動修改。',
    variant: 'warning',
  },
  manual: {
    label: '手動輸入',
    description: '此欄位由使用者手動輸入，沒有綁定問卷答案。',
    variant: 'secondary',
  },
  missing_source: {
    label: '未帶入',
    description: '已設定欄位綁定，但來源答案為空或格式不符合。',
    variant: 'outline',
  },
}

export function getFieldSourceStateMeta(state: CustomerApplicationFieldSourceState) {
  return sourceStateMeta[state]
}

export function ApplicationFieldSourceBadge({
  fieldValue,
  className,
  compact = false,
}: {
  fieldValue?: CustomerApplicationFieldValueContract
  className?: string
  compact?: boolean
}) {
  const meta = fieldValue ? sourceStateMeta[fieldValue.sourceState] : sourceStateMeta.manual
  const titleParts = [
    meta.description,
    fieldValue?.sourceQuestionTitle ? `來源問題：${fieldValue.sourceQuestionTitle}` : '',
    fieldValue?.sourceAnswerId ? `來源答案：${fieldValue.sourceAnswerId}` : '',
    fieldValue?.originalValue ? `原始值：${fieldValue.originalValue}` : '',
  ].filter(Boolean)

  return (
    <span
      className={cn('inline-flex items-center gap-2', className)}
      title={titleParts.join('\n')}
    >
      <Badge variant={meta.variant}>{meta.label}</Badge>
      {!compact && fieldValue?.sourceQuestionTitle ? (
        <span className="truncate text-xs text-slate-500">{fieldValue.sourceQuestionTitle}</span>
      ) : null}
    </span>
  )
}
